export const edgeGatewayMenus = () => ({
    id: `coln-1-collections`,
    label: 'Edge Gateway',
    path: '/management/edge-gateway/gateway-cockpit',
    isEnabled: true,
    svg: (
      <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
        <g id="SVGRepo_iconCarrier">
          <path fillRule="evenodd" clipRule="evenodd" d="M14 9a3 3 0 1 1-6 0 3 3 0 0 1 6 0zM5 8a5 5 0 1 1 10 0 5 5 0 0 1-10 0zm14 2a7 7 0 0 1 0 14H5a7 7 0 0 1 0-14h14zM5 22h14V13H5v9z" fill="#ffffff"></path>
        </g>
      </svg>
  
    ),
    subMenu: [
      {
        id: `coln-1-collections`,
        label: 'Gateway Cockpit',
        path: '/management/edge-gateway/gateway-cockpit',
        isEnabled: true,
        svg: (
          <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 10h-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zM6 8v2h2V8H6zm0 4v2h2v-2H6zm4-4v2h2V8h-2zm0 4v2h2v-2h-2zm4-4v2h2V8h-2zm0 4v2h2v-2h-2zm-8 4h8v2H8v-2z" fill="#007BFF" />
          </svg>
  
        ),
      },
      {
        id: `coln-1-collections`,
        label: 'Gateway',
        path: '/management/edge-gateway/gateways',
        isEnabled: true,
        svg: (
          <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 10h-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zM6 8v2h2V8H6zm0 4v2h2v-2H6zm4-4v2h2V8h-2zm0 4v2h2v-2h-2zm4-4v2h2V8h-2zm0 4v2h2v-2h-2zm-8 4h8v2H8v-2z" fill="#007BFF" />
          </svg>
  
        ),
      },
      {
        id: `coln-1-collections`,
        label: 'Gateway Registries',
        path: '/management/edge-gateway/gateway-registries',
        isEnabled: true,
        svg: (
          <svg className="h-5 w-5 fill-current mr-2" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 10h-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2zM6 8v2h2V8H6zm0 4v2h2v-2H6zm4-4v2h2V8h-2zm0 4v2h2v-2h-2zm4-4v2h2V8h-2zm0 4v2h2v-2h-2zm-8 4h8v2H8v-2z" fill="#007BFF" />
          </svg>
  
        ),
      },
     
       
    ]
  })